<template>
  <form v-on:submit.prevent class="box">
    <div v-show="isAuthenticated">
      <div class="field">
        <ValidationProvider
          ref="passwordObserver"
          v-slot="{ errors }"
          mode="lazy"
          rules="required|password:@confirm"
        >
          <label for="" class="label">Password</label>
          <div class="control has-icons-left">
            <input
              v-model="password"
              type="password"
              placeholder="*******"
              class="input"
              required
            />
            <span class="icon is-small is-left">
              <font-awesome-icon :icon="['fa', 'lock']" />
            </span>
          </div>
          <span v-bind:class="{ 'is-danger': errors[0] }" class="help">{{
            errors[0]
          }}</span>
        </ValidationProvider>
      </div>

      <div class="field">
        <ValidationProvider
          ref="confirmPasswordObserver"
          v-slot="{ errors }"
          mode="lazy"
          rules="required"
        >
          <label for="" class="label">Re-enter password</label>
          <div class="control has-icons-left">
            <input
              v-model="confirmPassword"
              type="password"
              placeholder="*******"
              class="input"
              required
            />
            <span class="icon is-small is-left">
              <font-awesome-icon :icon="['fa', 'lock']" />
            </span>
          </div>
          <span v-bind:class="{ 'is-danger': errors[0] }" class="help">{{
            errors[0]
          }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="field">
      <button @click="continueToMyAccount" class="button ps-button">
        Go to my account
      </button>
    </div>
  </form>
</template>

<script>
/* eslint-disable no-console */
// import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CreatePassword',
  data() {
    return {
      password: '',
      confirmPassword: '',
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated']
    },
  },
  methods: {
    continueToMyAccount(event) {
      this.$router.replace(`/dashboard`)
      this.$modal.hide('create-password-modal')
    },
  },
}
</script>
